/**
 * Haartool-vergelijker.
 *
 * Hangt een vinkje in de productkaarten die het thema al toont en laat onderin
 * een balk zien zodra er twee aangevinkt zijn. Geen endpoint, geen AI: prijs
 * en titel staan al in de kaart, en de eigenschappen komen uit één klein
 * JSON-bestand dat pas geladen wordt als iemand daadwerkelijk iets aanvinkt.
 *
 * De kaarten worden hier gevonden en niet in Liquid aangepast. Het thema zet
 * op elke kaart data-product-handle, data-url en data-default-variant-id; dat
 * is alles wat nodig is. Zo hoeft er geen themabestand open dat ook door
 * anderen bewerkt wordt.
 *
 * Over de lege vakjes: een product dat niet in het eigenschappenbestand staat
 * krijgt geen streepje maar een vraagteken, met een regel eronder die uitlegt
 * waarom. Een streepje zou betekenen "heeft dit niet", en dat weten we niet —
 * de winkel vermeldt het simpelweg niet overal.
 */
(function () {
  "use strict";

  var KAART = "[data-product-handle][data-url]";
  var VINK = "✓";

  /* Vanaf hoeveel beoordelingen een score getoond wordt. Daaronder staat er
     "Nog te weinig beoordelingen" — zie de toelichting bij de rij.

     Deze drempel gaat over het aantal, nooit over de hoogte van het cijfer.
     Een regel die alleen de lage scores verbergt is geen drempel maar een
     filter op kritiek, en dat mag in de EU ook niet (Omnibus-richtlijn). */
  var DREMPEL_BEOORDELINGEN = 10;

  /* Tellen of de vergelijker gebruikt wordt: getoond, aangevinkt, geopend,
     in het mandje. Alleen aantallen — geen cookie, geen id, niets over de
     bezoeker (zie lib/telling.ts in het haaradvies-project). Alleen in het
     gepubliceerde thema, zodat een voorbeeldweergave of de theme editor de
     cijfers niet vertroebelt. sendBeacon wacht op niets: tellen mag de
     winkel nooit ophouden. */
  var TELLER = "https://johnbeerens-haaradvies.vercel.app/api/vergelijker";

  function tel(soort, handles, centen) {
    try {
      var thema = window.Shopify && window.Shopify.theme;
      if (!thema || thema.role !== "main" || window.Shopify.designMode) return;
      if (!navigator.sendBeacon) return;
      var bericht = { t: soort, h: handles || [] };
      if (centen) bericht.c = centen;
      navigator.sendBeacon(TELLER, new Blob([JSON.stringify(bericht)], { type: "text/plain" }));
    } catch (e) {
      /* Niet tellen is beter dan iets stukmaken. */
    }
  }

  /** "€ 1.299,95" → 129995. */
  function naarCenten(prijs) {
    var getal = String(prijs || "").replace(/[^\d,.]/g, "").replace(/\.(?=\d{3}(\D|$))/g, "").replace(",", ".");
    var waarde = Math.round(parseFloat(getal) * 100);
    return isFinite(waarde) && waarde > 0 ? waarde : 0;
  }


  function esc(tekst) {
    return String(tekst == null ? "" : tekst).replace(/[&<>"']/g, function (teken) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[teken];
    });
  }

  /**
   * Het valutateken. Dit thema zet de prijs zonder teken in de kaart —
   * .price__current bevat letterlijk "119,95" — en haalt het symbool ergens
   * anders vandaan. In een vergelijktabel naast elkaar leest een kaal getal
   * als een specificatie in plaats van als een bedrag, dus zetten we het er
   * zelf voor.
   */
  function valuta() {
    var code = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    return { EUR: "€ ", USD: "$ ", GBP: "£ " }[code] || (code ? code + " " : "");
  }

/**
 * De productsoort zoals een klant hem leest.
 *
 * In Shopify staan die typen zoals ze ooit ingevoerd zijn: "fohn" zonder
 * trema naast "föhnborstel", en vier namen voor hetzelfde ding — borstel,
 * haarborstel, paddle brush, styling brush. Naast elkaar in een tabel valt dat
 * meteen op. Wat samengevoegd wordt, staat elders nog apart: "föhnborstel
 * elektrisch" verliest niets, want daar staat het kenmerk Elektrisch bij, en
 * "krultang set" heeft het kenmerk Set.
 */
  var SOORTNAAM = {
    fohn: "Föhn",
    reisfohn: "Föhn",
    "fohn accessoire": "Föhnaccessoire",
    fohnhouder: "Föhnhouder",
    "föhnborstel": "Föhnborstel",
    "föhnborstel elektrisch": "Föhnborstel",
    borstel: "Haarborstel",
    haarborstel: "Haarborstel",
    "paddle brush": "Haarborstel",
    "styling brush": "Haarborstel",
    stijlborstel: "Stijlborstel",
    warmteborstel: "Warmteborstel",
    kam: "Kam",
    stijltang: "Stijltang",
    krultang: "Krultang",
    "krultang set": "Krultang",
    multistyler: "Multistyler",
    airstyler: "Airstyler",
    opberghoes: "Opberghoes",
    trimmer: "Trimmer",
    "scheer accessoires": "Scheeraccessoire",
  };

  function soortNaam(soort) {
    if (!soort) return "";
    var s = String(soort).toLowerCase();
    // Onbekend type: eerste letter groot, zodat het niet uit de toon valt.
    return SOORTNAAM[s] || s.charAt(0).toUpperCase() + s.slice(1);
  }

  /** Wat er in de kaart staat. Ontbreekt er iets, dan blijft dat veld leeg. */
  function prijsMetTeken(ruw) {
    var tekst = String(ruw || "").trim().replace(/\s+/g, " ");
    if (!tekst) return "";
    // Staat er al een teken of een code in, dan laten we het zoals het is.
    return /[€$£]|[A-Z]{3}/.test(tekst) ? tekst : valuta() + tekst;
  }

  /** Het eerste bedrag uit een stuk tekst. .price__was bevat soms ook de nieuwe prijs. */
  function eersteBedrag(ruw) {
    var m = String(ruw || "").match(/\d[\d.]*(?:,\d{2})?/);
    return m ? prijsMetTeken(m[0]) : "";
  }

  function leesKaart(kaart) {
    var titel = kaart.querySelector(".product-block__title");
    var prijs = kaart.querySelector(".price__current");
    var was = kaart.querySelector(".price__was");
    var beeld = kaart.querySelector("img");
    return {
      was: was ? eersteBedrag(was.textContent) : "",
      handle: kaart.getAttribute("data-product-handle") || "",
      url: kaart.getAttribute("data-url") || "",
      variant: kaart.getAttribute("data-default-variant-id") || "",
      titel: titel ? titel.textContent.trim() : "",
      prijs: prijs ? prijsMetTeken(prijs.textContent) : "",
      beeld: beeld ? beeld.getAttribute("src") || "" : "",
    };
  }

  function init(root) {
    if (root.hvGestart) return;
    root.hvGestart = true;

    var knop = root.querySelector("[data-hv-open]");
    var stand = root.querySelector("[data-hv-stand]");
    var paneel = root.querySelector("[data-hv-paneel]");
    var uitslag = root.querySelector("[data-hv-uitslag]");
    if (!knop || !stand || !paneel || !uitslag) return;

    var max = parseInt(root.dataset.max, 10) || 4;
    var label = root.dataset.label || "Vergelijk";
    var gekozen = [];

    /* Wat er van een aangevinkt product nodig is voor de tabel (naam, prijs,
       foto, link), vastgelegd op het moment van aanvinken. De tabel las dat
       eerst uit de kaarten op de pagina; wie op pagina 1 iets aanvinkte en op
       pagina 3 nog iets, kreeg "Kies twee producten" omdat de kaart van
       pagina 1 er niet meer stond. */
    var bewaard = {};

    /* De keuze blijft bewaard tijdens het bezoek: na bladeren, herladen of
       een andere collectie (een merkpagina) staat hij er nog. Alleen in deze
       browser, alleen zolang het tabblad open is. */
    var OPSLAG = "hv-keuze";
    function bewaar() {
      try {
        sessionStorage.setItem(OPSLAG, JSON.stringify({ gekozen: gekozen, info: bewaard }));
      } catch (e) {
        /* Privévenster of geblokkeerde opslag: dan alleen binnen deze pagina. */
      }
    }
    try {
      var vorige = JSON.parse(sessionStorage.getItem(OPSLAG) || "null");
      if (vorige && Array.isArray(vorige.gekozen)) {
        gekozen = vorige.gekozen.filter(function (h) { return vorige.info && vorige.info[h]; }).slice(0, max);
        gekozen.forEach(function (h) { bewaard[h] = vorige.info[h]; });
      }
    } catch (e) {
      gekozen = [];
    }
    var eigenschappen = null;
    var bezig = null;

    function laadEigenschappen() {
      if (eigenschappen) return Promise.resolve(eigenschappen);
      if (!bezig) {
        bezig = fetch(root.dataset.eigenschappen, { headers: { Accept: "application/json" } })
          .then(function (r) {
            return r.ok ? r.json() : {};
          })
          .catch(function () {
            return {};
          })
          .then(function (data) {
            eigenschappen = data || {};
            return eigenschappen;
          });
      }
      return bezig;
    }

    /* --- het vinkje in de kaart ---------------------------------------- */

    /* Welke producten een vergelijkvakje krijgen: alleen die met een stekker.
       Bij een borstel valt er weinig te vergelijken — materiaal en diameter,
       en daar houdt het op — terwijl bij een stijltang tien eigenschappen
       meewegen. De lijst wordt gegenereerd uit de eigenschappen; zie
       scripts/maak-stekkerlijst.mjs.

       Een apart bestandje van 5 kB en niet de eigenschappen zelf (232 kB):
       dit wordt op élke collectiepagina geladen, ook door de telefoons. */
    var stekkers = null;

    function laadStekkers() {
      var bron = root.dataset.stekker;
      if (!bron) return Promise.resolve(null);
      return fetch(bron, { headers: { Accept: "application/json" } })
        .then(function (r) {
          if (!r.ok) throw new Error("stekkerlijst " + r.status);
          return r.json();
        })
        .then(function (lijst) {
          stekkers = Object.create(null);
          lijst.forEach(function (h) { stekkers[h] = true; });
          return stekkers;
        });
    }

    function vinkjeErin(kaart) {
      if (kaart.querySelector(".hv__kies")) return;
      var info = leesKaart(kaart);
      if (!info.handle) return;
      /* Nog niet geladen of niet gelukt: dan liever geen vakje dan een vakje
         bij een haarborstel. De vergelijker hoort bij apparaten. */
      if (!stekkers || !stekkers[info.handle]) return;

      /* Onder de prijs, niet op de foto.
         
         Op de foto is geen vrije plek: linksboven en rechtsboven staan de
         labels van het thema, rechtsboven ook nog een zwevende knop, en
         linksonder de bolletjes van de fotocarrousel. Waar je het ook legt,
         het dekt iets af.
         
         product-block__detail is het tekstblok onder de foto en zit níét in
         de productlink, dus een tik erop opent de productpagina niet. */
      var anker = kaart.querySelector(".product-block__detail") || kaart;

      var wrap = document.createElement("label");
      wrap.className = "hv__kies";
      wrap.innerHTML =
        '<input class="hv__vink" type="checkbox" value="' + esc(info.handle) + '">' +
        '<span class="hv__kies-tekst">' + esc(label) + "</span>";

      var vink = wrap.querySelector("input");
      vink.checked = gekozen.indexOf(info.handle) !== -1;
      vink.addEventListener("change", function () {
        if (vink.checked) {
          if (gekozen.length >= max) {
            vink.checked = false;
            /* Even zeggen waaróm er niets gebeurt, daarna terug naar normaal. */
            stand.textContent = "Maximaal " + max;
            setTimeout(werkBij, 1600);
            return;
          }
          gekozen.push(info.handle);
          bewaard[info.handle] = info;
          tel("vink", [info.handle]);
        } else {
          var i = gekozen.indexOf(info.handle);
          if (i !== -1) gekozen.splice(i, 1);
          delete bewaard[info.handle];
        }
        werkBij();
      });

      /* De kaart is één grote link; zonder dit opent een tik op het vinkje
         alsnog de productpagina. */
      wrap.addEventListener("click", function (event) {
        event.stopPropagation();
      });

      anker.appendChild(wrap);
    }

    function alleKaarten() {
      return Array.prototype.slice.call(document.querySelectorAll(KAART));
    }

    var getoondGeteld = false;

    function vinkjesPlaatsen() {
      alleKaarten().forEach(vinkjeErin);
      /* Eén keer per pagina, en pas als er echt een vakje staat: een
         collectie met alleen borstels telt niet als "vergelijker getoond". */
      if (!getoondGeteld && document.querySelector(".hv__vink")) {
        getoondGeteld = true;
        tel("getoond");
      }
    }

    /* --- balk en paneel ------------------------------------------------- */

    function toonBalk() {
      knop.hidden = gekozen.length < 2;
    }

    /**
     * Hoeveel ruimte onderin al bezet is, en hoeveel de pagina er onder krijgt.
     *
     * De winkel heeft zelf een zwevende Filter-knop linksonder en een
     * contactbel rechtsonder, en in de voorbeeldweergave staat er ook nog een
     * balk van Shopify. In plaats van die met de hand te ontwijken kijken we
     * wat er op die plek ligt: is dat iets anders dat vastgezet is, dan gaan
     * we erboven staan. Dat werkt ook als er ooit een cookiemelding bij komt.
     *
     * Over de hele breedte kijken, en per plek omhoog tot waar het zwevende
     * ding ophoudt. Zo telt alleen wat er echt staat: de contactknop van
     * Robin met zijn rode bolletje, de Filter-knop, de balk van Shopify.
     *
     * Eerder werd de bovenkant van alles ín zo'n zwevend blok gemeten. In de
     * contactknop zit ook het verborgen chatvenster, en dan ging de balk zo
     * hoog dat hij boven uit beeld viel. En lag de balk al over de
     * contactknop, dan zag de meting alleen de balk zelf en bleef hij daar
     * staan. Nu kijkt de meting door alles heen wat op een punt ligt, ook
     * door de balk zelf en door een pop-up over het hele scherm, en telt
     * alleen wat zichtbaar onderin vastgezet is (16 oktober 2026).
     */
    function hvOnderruimte() {
      var breedte = window.innerWidth;
      var hoog = window.innerHeight;
      var hoogste = hoog;
      var oordeel = new Map();

      /* Hoort dit punt bij iets dat onderin vastgezet is (en niet bij een
         schermvullende laag zoals een la of overlay)? */
      function zweeftOnderin(el) {
        var start = el;
        while (el && el !== document.body && el !== document.documentElement) {
          if (oordeel.has(el)) return oordeel.get(el);
          var cs = window.getComputedStyle(el);
          if (cs.position === "fixed" || cs.position === "sticky") {
            var r = el.getBoundingClientRect();
            var ja =
              r.bottom >= hoog - 48 &&
              r.height < hoog / 2 &&
              cs.visibility !== "hidden" &&
              Number(cs.opacity) > 0;
            oordeel.set(el, ja);
            oordeel.set(start, ja);
            return ja;
          }
          el = el.parentElement;
        }
        oordeel.set(start, false);
        return false;
      }

      var oud = root.style.pointerEvents;
      root.style.pointerEvents = "none";
      try {
        /* elementsFromPoint en niet elementFromPoint: alles op dat punt,
           ook wat onder een laag ligt. Een pop-up over het hele scherm (de
           kortingsmelding) verborg anders de contactknop eronder, en dan
           ging de balk er toch overheen. */
        var alles = document.elementsFromPoint
          ? function (px, py) { return document.elementsFromPoint(px, py); }
          : function (px, py) { var e = document.elementFromPoint(px, py); return e ? [e] : []; };
        for (var x = 8; x < breedte; x += 32) {
          for (var y = hoog - 4; y > hoog - 200; y -= 8) {
            var lijst = alles(Math.min(x, breedte - 8), y);
            for (var i = 0; i < lijst.length; i++) {
              var el = lijst[i];
              if (el === document.body || el === document.documentElement) break;
              if (root.contains(el)) continue;
              if (zweeftOnderin(el)) {
                hoogste = Math.min(hoogste, y);
                break;
              }
            }
          }
        }
      } catch (e) {
        /* elementFromPoint kan falen; dan geldt de standaardruimte. */
      }
      root.style.pointerEvents = oud;

      /* Acht pixels meetstap plus lucht erboven. */
      var vrij = Math.max(16, Math.round(hoog - hoogste) + 8 + 12);
      root.style.setProperty("--hv-onder", vrij + "px");

      /* De balk zweeft, dus de pagina weet niet dat hij er is en de laatste
         rij producten blijft eronder liggen. Die ruimte geven we terug — niet
         als vaste waarde maar als wat de balk werkelijk hoog is, want hij is
         op een telefoon hoger dan op een breed scherm. */
      var hoogte = knop.hidden ? 0 : Math.round(knop.getBoundingClientRect().height) + vrij + 12;
      document.body.style.setProperty("--hv-balk", hoogte + "px");
      document.body.classList.toggle("hv-balk-ruimte", hoogte > 0);
    }

    function werkBij() {
      bewaar();
      stand.textContent = "Vergelijk " + gekozen.length + " producten";
      toonBalk();
      hvOnderruimte();
      if (!knop.hidden) setTimeout(hvOnderruimte, 1200);

      // Vinkjes van andere kaarten met dezelfde handle meenemen.
      alleKaarten().forEach(function (kaart) {
        var v = kaart.querySelector(".hv__vink");
        if (v) v.checked = gekozen.indexOf(kaart.getAttribute("data-product-handle")) !== -1;
      });

      if (!paneel.hidden) tekenTabel();
    }

    function tekenTabel() {
      var kaarten = {};
      alleKaarten().forEach(function (k) {
        kaarten[k.getAttribute("data-product-handle")] = k;
      });

      laadEigenschappen().then(function (data) {
        var producten = gekozen
          .map(function (h) {
            /* Staat de kaart op deze pagina, dan de actuele gegevens; zo niet,
               dan wat er bij het aanvinken is vastgelegd. */
            return kaarten[h] ? leesKaart(kaarten[h]) : bewaard[h] || null;
          })
          .filter(Boolean)
          .map(function (p) {
            var info = data[p.handle] || {};
            /* Nooit null: een product zonder kenmerken krijgt een streepje,
               geen vraagteken. "We weten het niet" hoort niet in een tabel
               waar iemand een keuze op baseert. */
            p.kenmerken = info.kenmerken || [];
            p.beoordeling = info.beoordeling || null;
            /* Alleen wat de winkel zelf opgeeft. Bij de fabrikant opgezochte
               gegevens (info.extern) worden bewust niet gelezen: de
               vergelijker toont alleen onze eigen productinformatie. */
            p.specs = info.specs || {};
            p.merk = info.merk || "";
            p.soort = soortNaam(info.soort);
            return p;
          });

        if (producten.length < 2) {
          uitslag.innerHTML = '<p class="hv__voetnoot">Kies twee producten om te vergelijken.</p>';
          return;
        }

        /* De ja/nee-kenmerken die we zelf afleiden. Alleen een rij als
           minstens één product hem heeft; een rij met overal een streepje
           helpt niemand kiezen. */
        var kenmerkRijen = [];
        producten.forEach(function (p) {
          p.kenmerken.forEach(function (k) {
            if (kenmerkRijen.indexOf(k) === -1) kenmerkRijen.push(k);
          });
        });

        /* De rijen worden eerst als gegevens opgebouwd en pas daarna
           getekend. Dat is nodig voor twee dingen: ze in blokken groeperen, en
           kunnen zien welke rijen overal dezelfde waarde hebben — die kun je
           dan verbergen met "alleen de verschillen". */
        var rijenData = [];

        function rij(naam, cellen, ruw) {
          rijenData.push({ naam: naam, cellen: cellen, ruw: ruw });
        }

        /* De beoordeling bovenaan, zoals bij elke webshop die hier iets van
           maakt. De sterren tekenen we zelf: twee rijen van vijf over elkaar,
           waarvan de bovenste op de breedte van de score wordt afgeknipt.
           Dat schaalt mee met de tekstgrootte en heeft geen plaatjes nodig. */
        /* Anders dan bij de specificaties is hier één product met een score
           al genoeg. "Nog geen beoordelingen" is namelijk een antwoord: het
           product bestaat, er is alleen nog niets over gezegd. Bij een
           specificatie is een leeg vakje dat níét — daar weet je dan niet of
           het apparaat het kan of dat de winkel het niet vermeldt. */
        if (producten.some(function (p) { return p.beoordeling; })) {
          rij("Beoordeling", producten.map(function (p) {
            var b = p.beoordeling;
            if (!b) return '<td class="hv__geenreviews">Nog geen beoordelingen</td>';
            /* Altijd één decimaal: anders staat er "1" naast "4,7" en leest
               dat als een aantal in plaats van een cijfer. */
            var komma = esc(b.score.toFixed(1).replace(".", ","));

            /* Onder de drempel geen sterrenrij maar gewone tekst.
               Van de 160 tools met een score steunen er 60 op één enkele
               beoordeling en 86 op drie of minder. Vijf gevulde sterren zien
               er dan net zo stellig uit als bij een product met honderd
               recensies, en daar kiest iemand op. Het cijfer zelf blijft
               gewoon staan — het is echte informatie — alleen zonder het
               plaatje dat er een oordeel van maakt. */
            /* Onder de drempel helemaal geen cijfer. Een gemiddelde van één
               recensie is geen gemiddelde, en elk getal dat je er toch neerzet
               wordt door iemand vergeleken met de 4,7 ernaast.

               Dit werkt met opzet beide kanten op, en de cijfers laten zien
               dat het ook echt zo uitpakt: van de 127 scores onder deze
               drempel zijn er 74 een 4,5 of hoger en maar 11 een 2,0 of lager.
               Er verdwijnen dus bijna zeven keer zoveel goede als slechte.
               Zou de regel alleen de lage scores wegpoetsen, dan was het geen
               betrouwbaarheidsdrempel maar misleiding. */
            if (b.aantal < DREMPEL_BEOORDELINGEN) {
              return '<td class="hv__geenreviews">Nog te weinig beoordelingen</td>';
            }

            var deel = Math.max(0, Math.min(100, (b.score / 5) * 100));
            return '<td><span class="hv__sterren" role="img" aria-label="' +
              komma + ' van de 5 sterren, ' + b.aantal + ' beoordelingen">' +
              '<span class="hv__sterren-leeg">★★★★★</span>' +
              '<span class="hv__sterren-vol" style="width:' + deel.toFixed(1) + '%">★★★★★</span>' +
              "</span>" +
              '<span class="hv__score">' + komma +
              ' <span class="hv__aantal">(' + b.aantal + ")</span></span></td>";
          }), producten.map(function (p) {
            /* Wat er staat is wat er vergeleken wordt. Twee producten die
               allebei "nog te weinig beoordelingen" tonen zijn in de tabel
               gelijk, ook al verschillen hun cijfers — want die cijfers zie
               je niet. */
            var b = p.beoordeling;
            if (!b) return "geen";
            return b.aantal < DREMPEL_BEOORDELINGEN ? "te weinig" : String(b.score);
          }));
        }

        rij("Prijs", producten.map(function (p) {
          return '<td class="hv__prijscel">' + esc(p.prijs) + "</td>";
        }), producten.map(function (p) { return p.prijs; }));

        if (producten.some(function (p) { return p.was; })) {
          rij("Normaal", producten.map(function (p) {
            return '<td class="hv__was">' + (p.was ? esc(p.was) : "–") + "</td>";
          }), producten.map(function (p) { return p.was || "–"; }));
        }

        [["Merk", "merk"], ["Soort", "soort"]].forEach(function (paar) {
          if (!producten.every(function (p) { return p[paar[1]]; })) return;
          rij(paar[0], producten.map(function (p) {
            return "<td>" + esc(p[paar[1]]) + "</td>";
          }), producten.map(function (p) { return p[paar[1]]; }));
        });

        /* Specificaties zoals de productpagina ze opgeeft. Alleen waar de
           pagina zelf bewijst dat een veld fout is, wijkt de vergelijker af —
           nooit op grond van informatie van buiten. */
        function samengevoegd(p) {
          var uit = {};
          Object.keys(p.specs).forEach(function (n) { uit[n] = { waarde: p.specs[n] }; });

          /* "Draadloos: Ja" naast een snoerlengte op dezelfde pagina: dat kan
             niet allebei. Bij de Revlon Jumbo Waver staat het zo in de eigen
             specificatietabel. Een concrete snoerlengte is het sterkere
             bewijs, dus "draadloos" verdwijnt. */
          if (uit["Draadloos"] && /^ja$/i.test(uit["Draadloos"].waarde) && uit["Snoerlengte"]) {
            delete uit["Draadloos"];
            p.kenmerken = p.kenmerken.filter(function (k) { return k !== "Draadloos"; });
          }
          return uit;
        }
        producten.forEach(function (p) { p.alles = samengevoegd(p); });

        /* Alleen een rij als álle gekozen producten dat veld hebben: een
           waarde naast een leeg vakje zegt niets, want je weet dan nog steeds
           niet hoe het andere apparaat het doet. */
        var specNamen = [];
        producten.forEach(function (p) {
          Object.keys(p.alles).forEach(function (n) {
            if (specNamen.indexOf(n) === -1) specNamen.push(n);
          });
        });

        specNamen
          .filter(function (naam) {
            return producten.every(function (p) { return p.alles[naam]; });
          })
          .forEach(function (naam) {
            rij(naam, producten.map(function (p) {
              var v = p.alles[naam].waarde;
              if (/^ja$/i.test(v)) return '<td class="hv__ja">' + VINK + '<span class="hv__sr"> ja</span></td>';
              if (/^nee$/i.test(v)) return '<td class="hv__nee">–<span class="hv__sr"> nee</span></td>';
              return "<td>" + esc(v) + "</td>";
            }), producten.map(function (p) { return p.alles[naam].waarde; }));
          });

        /* Twee kenmerken die elkaar uitsluiten en toch allebei aan staan:
           dat komt doordat de winkel het product in beide subcollecties heeft
           gezet (grove én kleine krullen). Welke klopt weten we niet, dus
           laten we ze allebei weg in plaats van er twee vinkjes neer te
           zetten die elkaar tegenspreken. Het staat in de controle
           (scripts/controleer-vergelijker.mjs) zodat het in Shopify
           rechtgezet kan worden. */
        var UITSLUITEND = [["Grove staaf", "Dunne staaf"], ["Met klem", "Zonder klem"]];
        producten.forEach(function (p) {
          UITSLUITEND.forEach(function (paar) {
            if (p.kenmerken.indexOf(paar[0]) !== -1 && p.kenmerken.indexOf(paar[1]) !== -1) {
              p.kenmerken = p.kenmerken.filter(function (k) {
                return k !== paar[0] && k !== paar[1];
              });
            }
          });
        });

        /* Een afgeleid kenmerk is alleen betrouwbaar als ja. Dat het in de
           tekst niet genoemd wordt, betekent niet dat het product het niet
           heeft — en zo stond er live "nee" bij de MAE Steam Straight voor
           ionisch, automatische uitschakeling en dual voltage, terwijl de
           fabrikant alle drie noemt. Daarom zegt een kenmerk alleen "nee" als
           er echt bewijs voor is:

             - een specificatie op de productpagina zegt het: "Dual Voltage: Nee";
             - het materiaal is bekend en het is iets anders: een plaat van
               "Keramiek" is niet van titanium;
             - er staat een snoerlengte bij, dus het is niet draadloos.

           Zonder zulk bewijs: "niet vermeld". Liever eerlijk leeg dan een
           stellig nee dat niet klopt. */
        var ALS_SPEC = {
          "Automatische uitschakeling": "Schakelt automatisch uit",
          "Dual voltage": "Dual Voltage",
          "Draadloos": "Draadloos",
        };
        var UIT_MATERIAAL = {
          "Keramisch": /keramiek|keramisch|ceramic/i,
          "Titanium": /titanium/i,
          "Toermalijn": /toermalijn|tourmaline/i,
        };

        function kenmerkWaarde(p, k) {
          if (p.kenmerken.indexOf(k) !== -1) return "ja";
          var spec = ALS_SPEC[k] && p.alles[ALS_SPEC[k]];
          if (spec) {
            if (/^ja$/i.test(spec.waarde)) return "ja";
            if (/^nee$/i.test(spec.waarde)) return "nee";
          }
          if (UIT_MATERIAAL[k] && p.alles["Materiaal"]) {
            return UIT_MATERIAAL[k].test(p.alles["Materiaal"].waarde) ? "ja" : "nee";
          }
          if (k === "Draadloos" && p.alles["Snoerlengte"]) return "nee";
          return "onbekend";
        }

        kenmerkRijen = kenmerkRijen.filter(function (k) {
          /* Staat hetzelfde al als specificatierij in de tabel (bij elk
             product ingevuld), dan niet nog een keer als kenmerk. */
          var spec = ALS_SPEC[k];
          if (spec && producten.every(function (p) { return p.alles[spec]; })) return false;
          return producten.some(function (p) { return kenmerkWaarde(p, k) === "ja"; });
        });

        kenmerkRijen.forEach(function (k) {
          var waarden = producten.map(function (p) { return kenmerkWaarde(p, k); });
          rij(k, waarden.map(function (w) {
            if (w === "ja") return '<td class="hv__ja">' + VINK + '<span class="hv__sr"> ja</span></td>';
            if (w === "nee") return '<td class="hv__nee">–<span class="hv__sr"> nee</span></td>';
            return '<td class="hv__onbekend">niet vermeld</td>';
          }), waarden);
        });

        /* In blokken, zodat een lange tabel te overzien blijft. Wat nergens
           in past valt onder "Overig". */
        var GROEPEN = [
          ["Beoordeling en prijs", ["Beoordeling", "Prijs", "Normaal", "Merk", "Soort", "Productlijn"]],
          ["Geschikt voor", ["Haartype", "Voor krullend haar", "Curly Girl-proof", "Tegen pluis", "Ontwarrend", "Voor extensions", "Plat model", "Met keratine"]],
          ["Platen en opzetstukken", ["Keramisch", "Titanium", "Toermalijn", "Brede platen", "Beweegbare platen", "Klem", "Met klem", "Zonder klem", "Met opzetkammen", "Met opzetstukken", "Grove staaf", "Dunne staaf", "Diameter", "Materiaal", "Plaatbreedte"]],
          ["Temperatuur", ["Temperatuur", "Instelbare temperatuur", "Aantal standen", "Opwarmtijd"]],
          ["Gebruiksgemak", ["Schakelt automatisch uit", "Automatische uitschakeling", "Meedraaiend snoer", "Ionisch", "Infrarood", "Stoomfunctie", "Automatisch", "Lichtgewicht", "Mini / reisformaat", "Elektrisch", "Airstyler", "Diffuser", "Gewicht"]],
          ["Stroom en snoer", ["Draadloos", "Dual Voltage", "Dual voltage", "Snoerlengte", "Vermogen", "Accuduur", "Oplaadtijd"]],
        ];

        var geplaatst = {};
        var blokken = [];
        GROEPEN.forEach(function (g) {
          var inhoud = rijenData.filter(function (r) {
            return g[1].indexOf(r.naam) !== -1;
          });
          inhoud.forEach(function (r) { geplaatst[r.naam] = true; });
          if (inhoud.length) blokken.push([g[0], inhoud]);
        });
        var rest = rijenData.filter(function (r) { return !geplaatst[r.naam]; });
        if (rest.length) blokken.push(["Overig", rest]);

        var kolommen = producten.length + 1;
        var html =
          '<div class="hv__tabelwrap"><table class="hv__tabel"><thead><tr>' +
          '<th class="hv__hoek"><span class="hv__sr">Eigenschap</span></th>';
        producten.forEach(function (p) {
          html +=
            '<th scope="col"><a class="hv__kolomkop" href="' + esc(p.url) + '">' +
            (p.beeld ? '<img src="' + esc(p.beeld) + '" alt="" width="60" height="60" loading="lazy">' : "") +
            "<span>" + esc(p.titel) + "</span></a></th>";
        });
        html += "</tr></thead><tbody>";

        blokken.forEach(function (blok) {
          /* Is elke rij in dit blok overal gelijk, dan krijgt de kop dezelfde
             markering als die rijen. Anders blijft bij "alleen verschillen"
             een kopje staan met niets eronder — dat zag ik gebeuren bij twee
             kleurvarianten van dezelfde borstel. */
          var blokGelijk = blok[1].every(function (r) {
            return r.ruw.every(function (w) { return w === r.ruw[0]; });
          });
          html += '<tr class="hv__groep"' + (blokGelijk ? " data-hv-gelijk" : "") +
            '><th scope="colgroup" colspan="' + kolommen + '">' +
            esc(blok[0]) + "</th></tr>";
          blok[1].forEach(function (r) {
            var gelijk = r.ruw.every(function (v) { return v === r.ruw[0]; });
            html += '<tr' + (gelijk ? ' data-hv-gelijk' : "") + '><th scope="row">' +
              esc(r.naam) + "</th>" + r.cellen.join("") + "</tr>";
          });
        });

        html += '<tr><th scope="row"><span class="hv__sr">Bestellen</span></th>';
        producten.forEach(function (p) {
          html +=
            "<td>" +
            (p.variant
              ? '<button class="hv__mand" type="button" data-hv-add="' + esc(p.variant) +
                '" data-hv-naam="' + esc(p.titel) + '" data-hv-handle="' + esc(p.handle) +
                '" data-hv-prijs="' + esc(p.prijs) + '">In winkelwagen</button>'
              : '<a class="hv__bekijk" href="' + esc(p.url) + '">Bekijk</a>') +
            "</td>";
        });
        html += "</tr></tbody></table></div>";

        if (rijenData.length <= 2) {
          html +=
            '<p class="hv__voetnoot">Van deze producten vermeldt de winkel verder geen ' +
            "eigenschappen. Vergelijken kan hier op prijs en merk.</p>";
        }

        html += '<p class="hv__mand-melding" data-hv-melding hidden></p>';
        uitslag.innerHTML = html;
      });
    }

    knop.addEventListener("click", function () {
      paneel.hidden = false;
      tekenTabel();
      paneel.scrollIntoView({ block: "nearest" });
      tel("open", gekozen.slice());
    });

    /* Rijen waar alle producten hetzelfde scoren verbergen. Bij vier
       vergelijkbare stijltangen blijft er dan over waar ze echt in
       verschillen — dat is waar iemand op kiest. */
    var verschilKnop = root.querySelector("[data-hv-verschil]");
    if (verschilKnop) {
      verschilKnop.addEventListener("change", function () {
        paneel.classList.toggle("hv--alleen-verschil", verschilKnop.checked);
      });
    }

    root.querySelector("[data-hv-sluit]").addEventListener("click", function () {
      paneel.hidden = true;
    });

    root.querySelector("[data-hv-wis]").addEventListener("click", function () {
      gekozen = [];
      bewaard = {};
      paneel.hidden = true;
      werkBij();
    });

    /* --- in de winkelwagen, zonder de pagina te verlaten ----------------- */

    root.addEventListener("click", function (event) {
      var knop = event.target.closest ? event.target.closest("[data-hv-add]") : null;
      if (!knop || knop.disabled) return;
      event.preventDefault();

      var melding = root.querySelector("[data-hv-melding]");
      knop.disabled = true;
      knop.textContent = "Bezig…";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(knop.getAttribute("data-hv-add")), quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("cart " + r.status);
          knop.textContent = "Toegevoegd";
          knop.classList.add("is-toegevoegd");
          tel("mandje", [knop.getAttribute("data-hv-handle")], naarCenten(knop.getAttribute("data-hv-prijs")));
          /* Bewust geen aantal erbij. Deze winkel legt er soms automatisch een
             gratis sample bij, en dat gebeurt ná ons verzoek — het getal dat we
             dan uitlezen klopt een seconde later niet meer. Een verkeerd
             aantal is erger dan geen aantal. */
          if (melding) {
            melding.innerHTML =
              esc(knop.getAttribute("data-hv-naam")) +
              ' is toegevoegd. <a href="/cart">Naar winkelwagen</a>';
            melding.hidden = false;
          }
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        })
        .catch(function () {
          knop.disabled = false;
          knop.textContent = "Niet gelukt";
          if (melding) {
            melding.textContent = "Toevoegen lukte niet. Open het product om het zelf toe te voegen.";
            melding.hidden = false;
          }
        });
    });

    /* Eerst weten welke producten een stekker hebben, dan pas vakjes zetten.
       Dat duurt één verzoek; in die tijd klikt niemand al op vergelijken. */
    laadStekkers()
      .then(function () {
        vinkjesPlaatsen();
        /* Een bewaarde keuze van een vorige pagina: balk en vinkjes meteen. */
        if (gekozen.length) werkBij();
        hvOnderruimte();
      })
      .catch(function (fout) {
        console.warn("[vergelijker] stekkerlijst niet geladen, geen vakjes:", fout);
      });

    window.addEventListener("resize", hvOnderruimte);

    /* De contactknop en de Filter-knop laden of verschijnen soms later dan
       de balk, of pas na wat scrollen. Daarom bij een zichtbare balk nog eens
       meten: kort na het tonen, en na het scrollen als dat even stil is. */
    var naScroll = 0;
    window.addEventListener(
      "scroll",
      function () {
        if (knop.hidden) return;
        clearTimeout(naScroll);
        naScroll = setTimeout(hvOnderruimte, 250);
      },
      { passive: true },
    );

    /* De productlijst laadt bij door bij het scrollen. Nieuwe kaarten moeten
       hun vinkje ook krijgen, anders werkt het alleen boven de vouw. */
    if (typeof MutationObserver === "function") {
      var waarnemer = new MutationObserver(function () {
        vinkjesPlaatsen();
      });
      waarnemer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function start() {
    document.querySelectorAll("[data-hv]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  // De theme editor bouwt secties opnieuw op; dan moet dit opnieuw draaien.
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector ? event.target.querySelector("[data-hv]") : null;
    if (root) init(root);
  });
})();
